import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import ThresholdPanel from 'scoreboard/components/threshold-colors/threshold-panel'

const ThresholdColors = Backbone.View.extend({

	events: {
		'click .segmented, .continuous, .custom': '_setType'
	},

	/**
	 * Color Threshold Formatting #20258
	 *
	 * https://user-images.githubusercontent.com/1259395/48081253-946c6380-e1bd-11e8-89ed-5e08799cb259.png
	 *
	 * @param {Backbone.Model} options.model Model of ConditionalColor.kt
	 *
	 * @param {Object} options.aggregation Hash of aggregation data to aid in
	 * building the condition
	 *
	 * @param {FormView} options.formView
	 *
	 * @param {Boolean} [options.isShapeWidget=false] used to determine specific
	 * logic for shape widgets, such as when defining lowest and highest
	 * conditional value thresholds
	 *
	 * @param {String} [options.dataType] the data type of the thresholds
	 *
	 * @param {String} [options.currencyCode] the currency code of the thresholds
	 *
	 * @param {String} [options.precision] the decimal precision of the
	 * thresholds
	 *
	 * @param {Boolean} [options.isGaugeWidget=false] if this is for a dashboards
	 * gauge widget
	 */
	initialize: function(options = {}) {
		this.options = options
		this.isShapeWidget = options?.isShapeWidget ?? false
		this.isGaugeWidget = options?.isGaugeWidget ?? false
		this.formView = this.options.formView
	},

	render: function() {
		let type = this.model.get('type')
		if (type == 'custom') {
			//TODO render custom
		} else {
			this._renderThresholds(type)
		}

		return this
	},

	_renderThresholds: function(type) {
		this.thresholdPanel && this.thresholdPanel.remove()
		this.thresholdPanel = new ThresholdPanel({
			...this.model.attributes,
			isShapeWidget: this.isShapeWidget,
			dataType: this.options.dataType,
			currencyCode: this.options.currencyCode,
			precision: this.options.precision,
			isGaugeWidget: this.isGaugeWidget
		})
		_.each(['gradient', 'segments', 'reversed', 'thresholds'], name => {
			this.thresholdPanel.on(name, val => {
				this.model.set(name, val)
				this.formView.change()
			})
		})
		this.$el.append(this.thresholdPanel.el)
		this.thresholdPanel.render()
	},

	_setType: function(e) {
		let type = $(e.currentTarget).data('type')
		this.model.set('gradientType', type)
		this._renderThresholds(type)
		this.selectFormat(type)
	},

	selectFormat: function(type) {
		this.$('.type').removeClass('is-selected')
		this.$(`.type[data-type="${type}"]`).addClass('is-selected')
	},

	autoRemove: true
})

export default ThresholdColors
ThresholdColors.__filename__ = 'components/threshold-colors/threshold-colors.js'
